import { BsArchive, BsCheck2Circle } from 'react-icons/bs';

import { analyticsIds } from '../../../../../../constants/analyticsIds';
import { inAppText } from '../../../../../../constants/inAppText';
import { adminPageActivateUser, adminPageDeactivateUser, adminPageListUsers, adminPageUpdateFilters } from '../../../../../../redux/modules/adminPage';
import { hideModal, updateModalOptions } from '../../../../../../redux/modules/modal';
import { showDontAskAgainModal } from '../../../../../../utils/askAgainModalUtil';
import { createToast } from '../../../../../../utils/toastUtil';

// TODO: add delete option to both menus
export const activeMenuOptions = [
  {
    label: 'Deactivate User',
    icon: BsArchive,
    id: 'deactivateInsured',
    dataAnalyticsId: analyticsIds.adminSettingsPage.users.deactivateUserButton,
    handler: ({ e, dispatch }) => {
      e.preventDefault();
      e.stopPropagation();
      e.persist();

      const userId = parseInt(e.target.value, 10);
      const cookieId = 'hideDeactivateUserModal';
      const deactivateCurrentUser = async () => {
        dispatch(updateModalOptions({
          actionRequired: true,
          buttons: { primaryButtonOptions: { isLoading: true } }
        }));

        createToast({
          title: 'Deactivating User...',
          status: 'info',
          duration: 10000
        });

        await dispatch(adminPageDeactivateUser(userId));
        dispatch(adminPageListUsers());
        dispatch(hideModal());
      };

      showDontAskAgainModal({
        dispatch,
        cookieId,
        description: inAppText.adminPage.users.deactivateUser,
        onClick: deactivateCurrentUser,
        title: 'Deactivate User?'
      });
    }
  }
];

export const inactiveMenuOptions = [
  {
    label: 'Reactivate User',
    icon: BsCheck2Circle,
    id: 'reactivateInsured',
    dataAnalyticsId: analyticsIds.adminSettingsPage.users.reactivateUserButton,
    handler: ({ e, dispatch }) => {
      e.preventDefault();
      e.stopPropagation();
      e.persist();

      const userId = parseInt(e.target.value, 10);
      const cookieId = 'hideReactivateUserModal';
      const reactivateCurrentUser = async () => {
        dispatch(updateModalOptions({
          actionRequired: true,
          buttons: { primaryButtonOptions: { isLoading: true } }
        }));

        createToast({
          title: 'Reactivating User...',
          status: 'info',
          duration: 10000
        });

        await dispatch(adminPageActivateUser(userId));
        dispatch(adminPageListUsers());
        dispatch(adminPageUpdateFilters('user', 'active'));
        dispatch(hideModal());
      };

      showDontAskAgainModal({
        dispatch,
        cookieId,
        description: inAppText.adminPage.users.activateUser,
        onClick: reactivateCurrentUser,
        title: 'Reactivate User?'
      });
    }
  }
];
